import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Ticker from './Ticker';
import LogoMarquee from './LogoMarquee';
import Sidebar from './Sidebar';
import Splash from '../Splash';

const Layout = ({ children }) => {
  const [sideOpen, setSideOpen] = useState(false);
  const { pathname } = useLocation();
  const gamePlay = /^\/oyunlar\/(limbo|roulette|blackjack|mines)$/.test(pathname);

  useEffect(() => {
    document.body.style.overflow = (sideOpen || gamePlay) ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sideOpen, gamePlay]);

  return (
    <div className="min-h-screen min-h-dvh bg-bh-canvas text-bh-txt flex overflow-x-hidden max-w-[100%]">
      <Splash />
      <Sidebar open={sideOpen} onClose={() => setSideOpen(false)} />
      <div className={`flex-1 min-w-0 flex flex-col overflow-x-hidden ${gamePlay ? 'h-dvh max-h-dvh overflow-hidden' : ''}`}>
        <Header onMenu={() => setSideOpen(true)} />
        {!gamePlay && <Ticker />}
        {!gamePlay && <LogoMarquee />}
        <main
          className={`flex-1 w-full max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-8 overflow-x-hidden ${
            gamePlay
              ? 'min-h-0 overflow-hidden flex flex-col py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]'
              : 'py-4 sm:py-6 md:py-8 pb-[max(1.5rem,env(safe-area-inset-bottom))]'
          }`}
        >
          {children}
        </main>
        {!gamePlay && <Footer />}
      </div>
    </div>
  );
};

export default Layout;
